// Core
import { useState, useEffect, useRef } from 'react';
import { Box, Button, Flex, Text, Grid, Divider, Image, useColorMode } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';
import imageHeader from 'assets/img/all-prizes-without-g.png';
import adrianPortelli from 'assets/img/adrian-portelli.png';
import { getLinkLoyaltyMembership } from 'services/Utils';

// Components
import Reviews from 'components/Sliders/Reviews';
import { StarsIcon, MapIcon } from 'components/Icons/Icons';
import Li from 'components/Lists/List';

const SignUp = () => {
  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  const boxRef = useRef(null);
  const [isNear, setIsNear] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!boxRef.current) { return; }

      const rect = boxRef.current.getBoundingClientRect();
      if (rect.top < window.innerHeight - 300) { 
        setIsNear(true);
      } else {
        setIsNear(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Box 
        position="relative" 
        pb="100px" 
        w={{ base: '100%' }}
        left={{ base: '0' }}
        float="unset"
        alignItems="center"
        justifyContent="center"
        m="0px auto"
        maxW="1084px">
        { isDark && <Box className="abstract-grad animation-scale-grad" mt={{base: '170px', md: '50px'}} />}
        { isDark ? <Lines className="abstract-lines" /> : <LinesWhite className="abstract-lines" style={{opacity: 0.3}} />}
        { isDark && <Box className="abstract-grad animation-scale-grad" left="60%" transform="scale(2)" bottom="50%" />}
        <MapIcon position="absolute" fontSize="1360px" 
		    style={{
		    	zIndex: '-1', 
		    	maxWidth: '1660px', 
		    	w: '100%', 
		    	right: '-14%',
		    	top: '-10%', 
		    	height: 'auto', 
		    	opacity: '0.1'
		    }}/>
        <Image src={imageHeader} alt='prizes' 
          right={{base: 'unset', sm: '-10%', md: '-10%', lg: '-25%'}}
          top={{base: '140px', sm: '-80px', md: '-220px', lg: '-320px'}}
          maxW={{base: '480px', sm: '773px', md: '873px', lg: '100%'}}
          left={{base: '50%', sm: 'unset'}}
          transform={{base: 'translate(-50%, 0px)', sm: 'unset'}}
          w={{base: '480px', md: '100%'}}
          position="absolute" 
          zIndex="-1"/>
         <Box 
          display={{base: 'block', md: 'none'}}
          top="-60px"
          bg={ isDark ? '#00071C' : '#dfe9fd'} zIndex="-1" filter="blur(60px)" opacity="0.5" borderRadius="100%" w={{base: '100%', sm: '70%', md: 'none'}} h="290px" position="absolute" />

        <Text as="h1" variant="header" mt={{base: '44px', md: '88px', lg: '133px'}} fontSize={{base: '36px', md: '64px', lg: '72px'}}>Welcome to<br />
          <Box w="fit-content">
            <Text variant="header-gradient" 
              lineHeight={{base: '100px', lg: 'normal'}}
              fontSize={{base: '72px', md: '96px', lg: '128px'}} 
              mt="-16px">LMCT+</Text>
            <Divider 
              mt="-10px"
              h="2px"
              borderWidth="0"
              bg="linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #9EDFFF 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)"
            />
          </Box>
        </Text>

        <Flex gap={{base: '8px' ,sm: '24px'}} mt="18px" alignItems="center">
          <StarsIcon fontSize={{base: '24px', md: '42px'}}  />
          <Box
             borderRadius={{base: '8px', sm: '16px'}}
             p={{base: '4px 8px', sm: '8px 24px'}}
             background="white">
            <Text as="h2" variant="header-gradient" fontSize={{base: '36px', md: '64px'}}>premier SHOPPING TOOL</Text>
          </Box>
        </Flex>

        <Text as="h2" variant="header" fontSize={{base: '28px', md: '36px', lg: '48px'}} 
          mt="11px" mb={{base: '240px', sm: '0px'}}>OF Australia</Text>

        {/* <NavLink to="/auth/login"> */}
        <a href={getLinkLoyaltyMembership()} alt="Sign Up"> 
          <Button variant={ isDark ? 'button-lg-g' : 'button-lg' } maxW={{base: '100%', sm: '280px'}} mt="38px">Join Now</Button>
        </a> 
        {/* </NavLink> */}
      </Box>

      <Grid templateColumns={{ sm: '1fr', md: '1fr 0.8fr' }} gap="24px" templateRows='1fr' mt={{base: '-36px', md: '70px'}}>
      	<Box position="relative" className="animation-translate">
          <Box ref={boxRef} position={{base: 'relative', md: 'absolute'}} bottom="0" left={{md: '66px'}}>
        		<Image src={adrianPortelli} alt="Adrian Portelli" 
              maxW="428px" 
              w={{base: '100%', md: 'unset'}}
              position="relative" 
              opacity={isNear ? '1' : '0'}
              transform={isNear 
                ? { base: 'translate(-50%, -5px)', md: 'translate(-50%, 0px)' } 
                : { base: 'translate(-50%, 100px)', md: 'translate(-50%, 100px)' }
              }
              left="50%" />
        		<Lines className="abstract-lines" style={{transform: 'scale(0.7)', left: '-40%'}}  />
        		<Box overflow="hidden" position="absolute" height="200%" zIndex="-1" w="200%" bottom="0px" left="-50%">
              <Box bottom="0" zIndex="-1" bg="rgba(64, 155, 255, 0.82)" filter="blur(60px)" borderRadius="100%" w="50%" h="240px" transform="translate(-50%, 0px)" left="50%" position="absolute" />
        		</Box>
            <Divider 
  	            mt="-23px"
  	            h="2px"
  	            borderWidth="0"
  	            bg="linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #9EDFFF 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)"
  	          />
          </Box>
      	</Box>

      	<Box>
      		<Text as="h4" variant="header" fontSize={{base: '24px', md: '32px'}} fontStyle="normal" mt={{base: '8px', md: '73px'}} mb={{base: '24px', md: '32px'}}>ABOUT US</Text>
      		<Li text="Our platform not only facilitates access to exclusive deals from more than 1,000 partners but also empowers shoppers to make smart, cost-effective purchases all in one place." />
      		<Li text="At LMCT+, our users are not just visitors; they are paying members with a vested interest in utilizing our software to its fullest potential. This high intent to purchase makes our platform an attractive venue for advertisers and partners, ensuring high engagement rates and genuine transactions." />
      		<a href={getLinkLoyaltyMembership()} alt="Sign Up">
          {/* <NavLink to="/auth/login"> */}
            <Button variant={ isDark ? 'button-lg-g' : 'button-lg' } maxW={{base: '100%', sm: '280px'}} mt="38px">Join Now</Button>
          {/* </NavLink> */}
          </a> 
      	</Box>
      </Grid>

      <Box textAlign="center" pt={{base: '36px', md: '56px'}}>
      	<Text variant="header" textTransform="normal" fontSize={{base: '32px', md: '40px'}} fontWeight="600">
      		“Additionally, we pride ourselves on securing <span style={{color: '#099BFF'}}>exclusive partnerships </span> 
      		that provide <span style={{color: '#099BFF'}}>unique discounts</span> specifically for LMCT+ members, 
			a benefit not commonly found with typical affiliate programs.” 
      	</Text>
      	<Text variant="header" fontSize="30px" fontStyle="normal" letterSpacing="0px" pt="24px">Adrian Portelli</Text>
      	<Text variant="text-lg" fontSize="30px" fontWeight="500" fontSize="24px" color="#9FABCB" pt="4px">Founder</Text>
      </Box>

      <Text as="h4" variant="header" fontSize={{base: '24px', md: '32px'}} fontStyle="normal" mt={{base: '50px', md: '100px'}} mb={{base: '24px', md: '32px'}}>Clients Reviews</Text>
      <Reviews />

      <Box mt={{base: '0px', lg: '100px'}} />
    </>
  );
};

export default SignUp;